import React, { Suspense, useMemo } from 'react'
import { csx } from '@vtex/admin-ui'
import { graphql } from 'babel-plugin-relay/macro'
import { useSuspenseFragment } from 'react-relay-offline'

import { useProductPageUrlParams } from '../../hooks'
import type { ProductSkuRef_Product$key } from './__generated__/ProductSkuRef_Product.graphql'
import { ProductSkuRefText } from './ProductSkuRefText'
import { ProductSkuRefLoading } from './ProductSkuRefLoading'

const productFragment = graphql`
  fragment ProductSkuRef_Product on Product {
    skus {
      edges {
        node {
          id
          refId
        }
      }
    }
  }
`

type ProductSkuRefContentProps = {
  productRef: ProductSkuRef_Product$key
}

const ProductSkuRefContent = ({ productRef }: ProductSkuRefContentProps) => {
  const { selectedSkuId } = useProductPageUrlParams()
  const product = useSuspenseFragment(productFragment, productRef)

  const selectedSku = useMemo(() => {
    return product.skus.edges.find(
      (skuEdge) => skuEdge.node.id === selectedSkuId
    )
  }, [product.skus.edges, selectedSkuId])

  if (!selectedSku?.node.refId) {
    return null
  }

  return <ProductSkuRefText>{selectedSku.node.refId}</ProductSkuRefText>
}

export type ProductSkuRefProps = {
  productRef: ProductSkuRef_Product$key
}

export const ProductSkuRef = (props: ProductSkuRefProps) => (
  <div
    className={csx({ marginBottom: '$space-1' })}
    data-testid="product-sku-ref"
  >
    <Suspense fallback={<ProductSkuRefLoading />}>
      <ProductSkuRefContent {...props} />
    </Suspense>
  </div>
)
